<script>
import useMobileStyle from '@/mixins/useMobileStyle';
import UploadFiles from '@/components/ux/upload/Upload-files.vue';
import { ColorPicker } from 'vue3-colorpicker';
import convertToPrice from '@/utils/convertToPrice';
import { mapActions, mapState } from 'vuex';
import BANNER_DEFAULT from '@/pages/pagesContent/LogoComponent/constants';

export default {
  name: 'LogoComponent',
  components: {
    UploadFiles,
    ColorPicker,
  },
  mixins: [useMobileStyle],
  props: {
    currentPage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: BANNER_DEFAULT,
      id: null,
      name: 'LogoComponent',
      imageUrl: undefined,
      imageUrlMobile: undefined,
      isPreview: false,
      isMobile: false,
      error: {
        image: false,
        imageMobile: false,
      },
      backgroundColor: '',
      backgroundColorMobile: '',
    };
  },
  methods: {
    convertToPrice,
    ...mapActions({
      getPageContentAction: 'pageContent/getPageContent',
      createOrEditPageContentAction: 'pageContent/createOrEditPageContent',
    }),
    saveData() {
      const data = {
        id: this.id,
        page: this.currentPage.value,
        params: {
          name: this.name,
          pageKey: this.currentPage.value,
          imageUrl: this.imageUrl,
          imageUrlMobile: this.imageUrlMobile,
          isShowVideo: false,
          index: 0,
          productId: 0,
          optionId: 0,
          backgroundColor: this.backgroundColor,
          backgroundColorMobile: this.backgroundColorMobile,
        },
      };
      this.createOrEditPageContentAction(data);
    },
  },
  computed: {
    ...mapState({
      pageContent: (state) => state.pageContent.pageContent,
    }),
  },
  mounted() {
    this.getPageContentAction(this.currentPage.value);
  },
  watch: {
    currentPage(newV, prevV) {
      if (newV !== prevV) {
        this.getPageContentAction(newV.value);
      }
    },
    pageContent(newV) {
      if (newV && Object.keys(newV).length) {
        const logoComponent = newV.filter((block) => block.name === 'LogoComponent')[0] || {};
        this.id = logoComponent.id || '';
        this.imageUrl = logoComponent.imageUrl ? [logoComponent.imageUrl] : [];
        this.imageUrlMobile = logoComponent.imageUrlMobile
          ? [logoComponent.imageUrlMobile]
          : [];
      }
    },
    desktopImage(newV) {
      if (typeof newV === 'object' && newV.length === 0) {
        this.visibleImage = this.defaultOptions.imageUrl;
        this.imageUrl = '';
      }
    },
    mobileImage(newV) {
      if (typeof newV === 'object' && newV.length === 0) {
        this.visibleImageMobile = this.defaultOptions.imageUrlMobile;
        this.imageUrlMobile = '';
      }
    },
  },
};
</script>

<template>
  <div  v-if="!isPreview" class="wrap">
    <div class="row">
      <div class="column">
        <h4>Upload image for desktop:</h4>
        <upload-files
          :files="imageUrl"
          :is-multiple="false"
          :on-change="(value) => {
                this.imageUrl = value;
              }"
        />
      </div>
      <div class="column">
        <h4>Upload image for mobile:</h4>
        <upload-files
          :files="imageUrlMobile"
          :is-multiple="false"
          :on-change="(value) => {
                this.imageUrlMobile = value;
              }"
        />
      </div>
    </div>
    <div class="row">
      <div class="column">
        <h4>Desktop main color:</h4>
        <color-picker v-model:pureColor="backgroundColor" />
      </div>
      <div class="column">
        <h4>Mobile second color:</h4>
        <color-picker v-model:pureColor="backgroundColorMobile" />
      </div>
    </div>
    <div class="row button">
      <a-button
        @click="saveData()"
        type="primary"
      >
        Save
      </a-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import 'src/styles/variables.scss';
@import 'src/styles/media.scss';
@import 'src/styles/fonts.scss';

.wrap{
  width: 700px;
  margin: 150px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

.row {
  width: 552px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 50px;
  align-items: center;
}

.mini-row {
  width: 250px;
}

.column {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
  margin-bottom: 10px;
}

.button {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

h4 {
  width: 250px;
}
</style>
